import type { FunctionReturnType } from "convex/server";
import type { api } from "../../../convex/_generated/api";

/** Scorecard proposée à la création de campagne (cf. `listerScorecardsPourCampagne`). */
export type ScorecardOption = FunctionReturnType<
  typeof api.scorecards.listerScorecardsPourCampagne
>[number];

/** « v2 · 28/09/2026 » ; sans date pour une version publiée avant la marque de publication. */
export function libelleVersion(version: ScorecardOption["versions"][number]): string {
  if (version.publieeLe === undefined) return `v${version.numero}`;
  const date = new Date(version.publieeLe).toLocaleDateString("fr-FR");
  return `v${version.numero} · ${date}`;
}
